import React, { memo, FC } from 'react';
import { Youtube, Image } from 'app/shared/components';
import { useStyles } from './styles';

export interface MediaProps {
  imageLink?: string;
  youtubeID?: string;
}

const Media: FC<MediaProps> = ({ imageLink = '', youtubeID = '' }) => {
  const styles = useStyles();

  const hasImageLink = imageLink !== '';
  const hasYoutubeID = youtubeID !== '';

  return (
    <>
      {(hasYoutubeID || hasImageLink) && (
        <span className={styles.common}>
          {hasImageLink && <Image src={imageLink} lazyload />}
          {hasYoutubeID && <Youtube videoId={youtubeID} />}
        </span>
      )}
    </>
  );
};

export default memo(Media);
